export const INSIGHT_BUTTON_MARK_KEY = 'jira.frontend.classic-board.insight-button';
export const LOAD_START_INSIGHT_BUTTON_MARK_KEY = 'LOAD_START_INSIGHT_BUTTON_MARK_KEY';
export const READY_START_INSIGHT_BUTTON_MARK_KEY = 'READY_START_INSIGHT_BUTTON_MARK_KEY';
